<nav 
  id="sidebar" 
  class="navbar-dark bg-dark" 
  [class.hidden]="!settings.theme.showMenu"
>
  <ul class="navbar-nav w-100">
    <ng-container *ngFor="let menuItem of menuItems; let i = index">
      <app-side-nav-item [menuItem]="menuItem" (changeExpanded)="editExpanded($event)" [attr.data-testid]="'side-nav-item-' + i"></app-side-nav-item>
    </ng-container>
  </ul>    
</nav>





// WEBPACK FOOTER //
// ./src/app/core/components/menu/side-nav/side-nav.component.html